import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type {
  DigestPreviewParams,
  PortalDigestPreviewResponse,
} from '../model/types';

export const getDigestPreviewAPI = async (params: DigestPreviewParams) => {
  const response = await baseAPI.post<PortalDigestPreviewResponse>(
    '/portal-digest/preview',
    params,
  );
  return response.data;
};

/**
 * A single preview request: the on-screen form values to build the digest
 * with, plus `seq` so clicking Preview again always refetches even when the
 * values did not change.
 */
export interface DigestPreviewRequest {
  params: DigestPreviewParams;
  seq: number;
}

/**
 * Disabled until the first Preview click (`request === null`). The query key
 * carries the request, so every Preview click fetches fresh data, and
 * `refetch()` (e.g. on window focus) rebuilds with the same values.
 */
export const useGetDigestPreview = (request: DigestPreviewRequest | null) => {
  return useQuery({
    queryKey: [KEYS.PORTAL_DIGEST_PREVIEW, request],
    queryFn: () => getDigestPreviewAPI(request?.params ?? {}),
    enabled: request !== null,
    staleTime: 0,
    retry: false,
  });
};
